// ReloadContext.tsx
import React, { createContext, useContext, useState } from "react";

type AppReloadContextValue = {
  reloadTrigger: boolean;
  setReloadTrigger: (value: boolean) => void;
};

const AppReloadContext = createContext<AppReloadContextValue | undefined>(undefined);

export const AppReloadProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [reloadTrigger, setReloadTrigger] = useState(false);

  return (
    <AppReloadContext.Provider value={{ reloadTrigger, setReloadTrigger }}>
      {children}
    </AppReloadContext.Provider>
  );
};

export const useReload = (): AppReloadContextValue => {
  const ctx = useContext(AppReloadContext);
  if (!ctx) throw new Error("useReload must be inside ReloadProvider");
  return ctx;
};
